import {Component, OnInit, ViewChild} from '@angular/core';
import {RicambiService} from '../service/ricambi.service';
import {Categoria} from '../models/categoria';
import {Macchina} from '../models/macchina';
import {TwsCategoriaComponent} from '../tws-categoria/tws-categoria.component';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Location} from '@angular/common';
import 'rxjs/add/operator/switchMap';


@Component({
    selector: 'app-tws-macchine',
    templateUrl: './tws-macchine.component.html',
    styleUrls: ['./tws-macchine.component.scss']
})
export class TwsMacchineComponent implements OnInit {
    @ViewChild(TwsCategoriaComponent) private categorieComponent: TwsCategoriaComponent;
    macchineTrovate: Array<Macchina>;//da ricerca
    categorie: Array<Categoria>;//categorie correnti
    categoriaCorrente: Categoria = new Categoria(0, "", "", 0);
    codice: string;
    descrizione: string;
    matricola: string;
    lastCategoria: any;
    ricerca: boolean = false;

    constructor(private ricambiService: RicambiService,
        private route: ActivatedRoute, private location: Location, private router: Router) {

    }
    ngDoCheck() {
        let idCategoria = +this.route.snapshot.params['id'];
        if (idCategoria) {
            if (idCategoria != this.lastCategoria) {
                this.lastCategoria = idCategoria;
                this.ngOnInit();
            }
        }
    }

    ngOnInit() {
        console.log("init");
        //tanto dovrebbe essere cache
        this.reset();
        let idCategoria = +this.route.snapshot.params['id'];
        if (idCategoria) {
            this.lastCategoria = idCategoria;
            this.ricambiService.getCategorie().then(heroes => {
                let categoria: Categoria[] = heroes.filter(categoria => categoria.id == idCategoria);
                this.onRouteCategoria(categoria[0]);
            });

        }
    }

    reset(): void {
        this.macchineTrovate = new Array<Macchina>();//da ricerca
        this.categoriaCorrente = new Categoria(0, "", "", 0);
        this.ricerca = false;
        this.toggle =false;
        if (this.categorieComponent) {
            this.categorieComponent.categoria = this.categoriaCorrente;
        }
    }

    onRouteCategoria(hero: Categoria): void {
        this.categoriaCorrente = hero;
        if (this.categorieComponent) {
            this.categorieComponent.categoria = this.categoriaCorrente;
        }
        this.ricambiService.getMacchine(this.categoriaCorrente).then(mac => this.macchineTrovate = mac);
        this.ricerca = false;
        this.codice = "";
        this.descrizione = "";
        this.matricola = "";
    }
    clickMacchina(macchina:number):void{
        this.router.navigate(['/scheda', macchina]);
    }

    onSelectCategoria(hero: Categoria): void {
        this.router.navigate(['/macchine', hero.id]);

        this.categoriaCorrente = hero;
        if (this.categorieComponent) {
            this.categorieComponent.categoria = this.categoriaCorrente;
        }
        this.ricambiService.getMacchine(this.categoriaCorrente).then(mac => this.macchineTrovate = mac);
        this.ricerca = false;
        this.codice = "";
        this.descrizione = "";
        this.matricola = "";
        this.toggle =false;

    }
    get navigazione(): Array<Categoria> {
        if (this.categorieComponent) {
            return this.categorieComponent.navigazione;
        } else {
            return new Array<Categoria>();
        }
    }

    cercaMacchine(): void {
        this.ricerca = true;
        this.ricambiService.cercaMacchine(this.codice, this.descrizione, this.matricola).then(mac => this.risultatiRicerca(mac));
    }

    risultatiRicerca(mac: Macchina[]): void {
        this.macchineTrovate = mac
        this.ricerca = true;
        this.toggle =false;
    }
    toggle: boolean = false;
    clickToggle(): void {
        this.toggle = !this.toggle;
    }
}



// WEBPACK FOOTER //
// ./src/app/tws-macchine/tws-macchine.component.ts